import React, { createContext } from 'react';

// Define the interface for a single position
export interface TrackingPositionTypes {
  position: number | null;
}

// Define the context type
export interface NavigationContextType {
  positions: TrackingPositionTypes[];
  setPosition: (index: number, position: number) => void;
}

// Initial context value
export const initialPositionContext: TrackingPositionTypes[] = [
  { position: null },
  { position: null },
  { position: null },
  { position: null },
];

// Create the context
export const NavigationContext = createContext<
  NavigationContextType | undefined
>(undefined);
